class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this._threshold = parseInt(this.dataset.threshold, 10);
    this._textProgress = this.dataset.textProgress;
    this._textAchieved = this.dataset.textAchieved;
    this._barColor = this.dataset.barColor;
    this._achievedColor = this.dataset.achievedColor;

    this._messageEl = this.querySelector('.free-shipping-bar__message');
    this._fillEl = this.querySelector('.free-shipping-bar__fill');
    this._iconEl = this.querySelector('.free-shipping-bar__icon');

    this._onCartUpdated = this._onCartUpdated.bind(this);
    document.addEventListener('cart:updated', this._onCartUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this._onCartUpdated);
  }

  _formatMoney(cents) {
    const format = window.MinimogSettings?.money_format;
    if (typeof formatMoney === 'function' && format) {
      return formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  _onCartUpdated() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => this._render(cart.total_price))
      .catch(() => {});
  }

  _render(totalCents) {
    const remaining = Math.max(0, this._threshold - totalCents);
    const pct = Math.min(100, (totalCents / this._threshold) * 100);
    const achieved = totalCents >= this._threshold;

    this.classList.toggle('free-shipping-bar--achieved', achieved);

    if (this._messageEl) {
      if (achieved) {
        this._messageEl.innerHTML = this._textAchieved;
      } else {
        const amount = `<strong>${this._formatMoney(remaining)}</strong>`;
        this._messageEl.innerHTML = this._textProgress.replace('[amount]', amount);
      }
    }

    if (this._fillEl) {
      this._fillEl.style.width = `${pct}%`;
      const color = achieved ? this._achievedColor : this._barColor;
      this._fillEl.style.backgroundColor = color;
      if (this._iconEl) {
        this._iconEl.style.backgroundColor = color;
      }
    }
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);
